import { NotificationInterface } from "@swivl-mono/types";
import { Button } from "@swivl-mono/ui";
import { HiBellAlert } from "react-icons/hi2";
import useHasPendingUpdates from "../../Hooks/useHasPendingUpdates";
import NotificationsModel from "../../Models/Notifications/Notifications.Model";
import { PendingUpdateType } from "../../Models/Pending/Pending.Model";

interface BaseToastGenericProps {
  notification: NotificationInterface;
}

const BaseToastGeneric = (props: BaseToastGenericProps) => {
  const { notification } = props;
  const isPending = useHasPendingUpdates([{ type: PendingUpdateType.NOTIFICATION_ACKNOWLEDGED, id: notification.id }]);

  const handleDismiss = () => {
    NotificationsModel.acknowledgeNotification(notification);
  }

  return (
    <>
      <div className="flex gap-4 items-center">
        {/* icon */}
        <HiBellAlert className="size-[25px] fill-black shrink-0" />
        <div className="flex flex-col justify-center px-1">
          {/* title */}
          <span className="font-semibold text-sm">{notification.data?.title || "System Alert"}</span>
          {/* subtitle */}
          <span className="text-grey-600 text-xs lg:text-sm">{notification.data?.message}</span>
        </div>
      </div>

      {/* dismiss button */}
      <Button
        loading={isPending}
        onClick={handleDismiss}
      >
        Dismiss
      </Button>
    </>
  )
}

export const ToastGeneric = BaseToastGeneric;
